import { getNewErrorsArray } from '../../../utils/formatters';
import { GeneralActionsNames } from '../general/general.actions';
import { CustomerAssignmentsActionsNames } from './customerAssignments.actions';
import { CustomerAssignmentsState, CustomerAssignmentsAction } from './type';

const initialState: CustomerAssignmentsState = {
  isLoading: false,
  error: null,
  customerAssignments: [],
  lastAddResult: null,
};

const customerAssignmentsReducer = (
  state: CustomerAssignmentsState = initialState,
  action: CustomerAssignmentsAction
): CustomerAssignmentsState => {
  switch (action.type) {
    case CustomerAssignmentsActionsNames.GET_CUSTOMER_ASSIGNMENTS.START:
      return {
        ...state,
        error: null,
        isLoading: true,
        customerAssignments: [],
      };
    case CustomerAssignmentsActionsNames.GET_CUSTOMER_ASSIGNMENTS.FULFILLED:
      return {
        ...state,
        isLoading: false,
        customerAssignments: action.payload,
      };
    case CustomerAssignmentsActionsNames.GET_CUSTOMER_ASSIGNMENTS.REJECTED:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    case CustomerAssignmentsActionsNames.ADD_RANGE_CUSTOMER_ASSIGNMENTS.START:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case CustomerAssignmentsActionsNames.ADD_RANGE_CUSTOMER_ASSIGNMENTS.FULFILLED:
      return {
        ...state,
        isLoading: false,
        lastAddResult: action.payload,
      };
    case CustomerAssignmentsActionsNames.ADD_RANGE_CUSTOMER_ASSIGNMENTS.REJECTED:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    case CustomerAssignmentsActionsNames.REMOVE_CUSTOMER_ASSIGNMENT.START:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case CustomerAssignmentsActionsNames.REMOVE_CUSTOMER_ASSIGNMENT.FULFILLED:
      return {
        ...state,
        isLoading: false,
        customerAssignments: state.customerAssignments.filter(
          (c: any) => c.phoneNumber !== action.payload.phoneNumber
        ),
      };
    case CustomerAssignmentsActionsNames.REMOVE_CUSTOMER_ASSIGNMENT.REJECTED:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    case CustomerAssignmentsActionsNames.UPDATE_CUSTOMER_ASSIGNMENT.START:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case CustomerAssignmentsActionsNames.UPDATE_CUSTOMER_ASSIGNMENT.FULFILLED:
      return {
        ...state,
        isLoading: false,
        customerAssignments: state.customerAssignments.map((c: any) =>
          c.phoneNumber === action.payload?.updated.phoneNumber
            ? action.payload.updated
            : c
        ),
      };
    case CustomerAssignmentsActionsNames.UPDATE_CUSTOMER_ASSIGNMENT.REJECTED:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    case GeneralActionsNames.CLEAR_ERRORS.FULFILLED:
      return {
        ...state,
        error: getNewErrorsArray(state.error, action.payload),
      };
  }
  return state;
};

export default customerAssignmentsReducer;
